'use client';

import { Button } from '@/src/components/ui/button';
import { useRouter } from '@/src/i18n/navigation';
import { cn } from '@/src/lib/utils/command';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useLocale, useTranslations } from 'next-intl';

const BackToPrev = (props: {
  title?: string;
  className?: string;
  buttonClassName?: string;
  hideText?: boolean;
  subtitle?: string;
}) => {
  const currentLanguage = useLocale();
  const router = useRouter();
  const t = useTranslations('order');

  return (
    <div className={cn('my-2 flex max-w-max justify-start gap-2 rounded-full', props.className)}>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          router.back();
        }}
        className={cn(
          'bg-secondary flex items-center gap-2 rounded-full p-2',
          props.buttonClassName,
        )}
      >
        <span>{currentLanguage === 'en' ? <ArrowLeft /> : <ArrowRight />}</span>
        {!props.hideText && <span className=" ">{props.title || t('GoBack')}</span>}
      </button>
      {props.subtitle && (
        <span className="bg-secondary flex items-center rounded-full px-4 py-2 text-sm font-semibold">
          {props.subtitle}
        </span>
      )}
    </div>
  );
};

export default BackToPrev;
